exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\nhtml, body {\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 100%;\r\n}\r\nbody{\r\n    font-family: \"Helvetica Neue\",sans-serif;\r\n      font-weight: lighter;\r\n}\r\n\r\n\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// E:/Angular/website-angular/node_modules/css-loader?{"sourceMap":false,"import":false}!E:/Angular/website-angular/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!E:/Angular/website-angular/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles